import React from 'react';
import { getMockServices } from '../data/mockData';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n/config';

const Services = () => {
  const { t } = useTranslation();

  // Wait for i18n to be initialized before rendering services
  if (!i18n.isInitialized) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="text-xl text-gray-600">Loading services...</div>
        </div>
      </section>
    );
  }

  // Get translated mock services - only after i18n is ready
  const displayServices = getMockServices(t);

  // Removed error display - using mock data as fallback

  return (
    <section id="services-section" className="py-8 sm:py-12 lg:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="flex items-center justify-center mb-4">
            <img 
              src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=50&h=50&fit=crop&crop=center" 
              alt="separator" 
              className="w-6 h-6 sm:w-8 sm:h-8"
            />
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 uppercase tracking-wide px-4">
            {t('services.sectionTitle')}
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {displayServices?.map((service) => (
            <div key={service.id} className="service-card bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src={service.image} 
                alt={service.title}
                className="w-full h-40 sm:h-48 object-cover"
              />
              <div className="p-4 sm:p-6 text-center">
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4 uppercase leading-tight">
                  {service.title}
                </h3>
                <a
                  href={`/service/${service.id}`}
                  className="inline-block bg-blue-500 text-white px-4 sm:px-6 py-2 rounded hover:bg-blue-600 transition-colors text-sm sm:text-base"
                >
                  {t('services.viewDetails')}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <div className="flex justify-center mt-6 sm:mt-8 space-x-4">
          <button className="text-gray-400 hover:text-gray-600 text-sm sm:text-base">{t('services.prev')}</button>
          <button className="text-gray-400 hover:text-gray-600 text-sm sm:text-base">{t('services.next')}</button>
        </div>
      </div>
    </section>
  );
};

export default Services;